import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { createStyles } from '@mantine/core';
import { addBreakpointMedia, objectDeepMerging, isNumber, ThemeBreakpoints } from '../../utils/index.js';
import { RootVariable } from './constant.js';

var _defaultVariable;
var resetVariable = Object.values(RootVariable).reduce(function (ac, cr) {
  ac[cr] = 'none';
  return ac;
}, {});
var defaultVariable = (_defaultVariable = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defaultVariable, RootVariable.CHECKBOX_CHECKED_BG, 'transparent'), RootVariable.CHECKBOX_CHECKED_HOVER_BG, 'transparent'), RootVariable.CHECKBOX_CHECKED_DISABLED_BG, 'transparent'), RootVariable.CHECKBOX_CHECKED_BORDER_COLOR, 'var(--gui-color-icon-1)'), RootVariable.CHECKBOX_CHECKED_HOVER_BORDER_COLOR, 'var(--gui-color-icon-1)'), RootVariable.CHECKBOX_CHECKED_DISABLED_BORDER_COLOR, 'var(--gui-color-icon-4)'), RootVariable.CHECKBOX_BG, 'transparent'), RootVariable.CHECKBOX_HOVER_BG, 'transparent'), RootVariable.CHECKBOX_DISABLED_BG, 'var(--gui-color-icon-4)'), RootVariable.CHECKBOX_BORDER_COLOR, 'var(--gui-color-icon-4)'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defaultVariable, RootVariable.CHECKBOX_HOVER_BORDER_COLOR, 'var(--gui-color-icon-1)'), RootVariable.CHECKBOX_DISABLED_BORDER_COLOR, 'var(--gui-color-icon-4)'), RootVariable.CHECKBOX_BORDER_WIDTH, '1px'), RootVariable.CHECKBOX_RADIUS, '2px'), RootVariable.CHECKBOX_CHECKED_COLOR, 'var(--gui-color-icon-1)'), RootVariable.CHECKBOX_CHECKED_DISABLED_COLOR, 'var(--gui-color-icon-4)'), RootVariable.CHECKBOX_CHECKED_HOVER_COLOR, 'var(--gui-color-icon-1)'), RootVariable.CHECKBOX_LABEL_COLOR, 'var(--gui-color-text-1)'), RootVariable.CHECKBOX_LABEL_DISABLED_COLOR, 'var(--gui-color-text-7)'), RootVariable.CHECKBOX_LABEL_GAP, '8px'), _defineProperty(_defaultVariable, RootVariable.CHECKBOX_LABEL_LINE_HEIGHT, 1.5));
var getDefaultStyles = function getDefaultStyles() {
  return {
    root: _objectSpread2(_objectSpread2({}, resetVariable), defaultVariable)
  };
};
var getCurrentVariantAndSizeStyle = function getCurrentVariantAndSizeStyle(_ref) {
  var size = _ref.size,
    textSize = _ref.textSize,
    fw = _ref.fw;
  return objectDeepMerging(getDefaultStyles(), {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.CHECKBOX_LABEL_FONT_WEIGHT, fw), RootVariable.CHECKBOX_LABEL_FONT_SIZE, isNumber(textSize) ? textSize + 'px' : textSize), RootVariable.CHECKBOX_SIZE, isNumber(size) ? size + 'px' : size), RootVariable.CHECKBOX_ICON_TRANSFORM, isNumber(size) && isNumber(textSize) ? "translateY(".concat((textSize * 1.5 - size) / 2, "px)") : 'translateY(2px)')
  });
};
var useCheckboxStyle = createStyles(function (_, _ref2, getRef) {
  var size = _ref2.size,
    textSize = _ref2.textSize,
    hasLabel = _ref2.hasLabel,
    breakpoints = _ref2.breakpoints,
    fw = _ref2.fw;
  return addBreakpointMedia(function (_ref3) {
    var size = _ref3.size,
      textSize = _ref3.textSize;
    return objectDeepMerging(getCurrentVariantAndSizeStyle({
      size: size,
      textSize: textSize,
      fw: fw
    }), {
      root: {},
      body: {},
      input: _defineProperty(_defineProperty(_defineProperty({
        cursor: 'pointer',
        width: "var(".concat(RootVariable.CHECKBOX_SIZE, ")"),
        height: "var(".concat(RootVariable.CHECKBOX_SIZE, ")"),
        borderRadius: "var(".concat(RootVariable.CHECKBOX_RADIUS, ")"),
        border: "var(".concat(RootVariable.CHECKBOX_BORDER_WIDTH, ") solid var(").concat(RootVariable.CHECKBOX_BORDER_COLOR, ")"),
        backgroundColor: "var(".concat(RootVariable.CHECKBOX_BG, ")"),
        '&:checked': {
          backgroundColor: "var(".concat(RootVariable.CHECKBOX_CHECKED_BG, ")"),
          borderColor: "var(".concat(RootVariable.CHECKBOX_CHECKED_BORDER_COLOR, ")")
        },
        '&:checked:disabled': {
          backgroundColor: "var(".concat(RootVariable.CHECKBOX_CHECKED_DISABLED_BG, ")"),
          borderColor: "var(".concat(RootVariable.CHECKBOX_CHECKED_DISABLED_BORDER_COLOR, ")")
        },
        '&:checked:hover:not(:disabled)': {
          backgroundColor: "var(".concat(RootVariable.CHECKBOX_CHECKED_HOVER_BG, ")"),
          borderColor: "var(".concat(RootVariable.CHECKBOX_CHECKED_HOVER_COLOR, ")")
        },
        '&:hover:not(:disabled)': {
          backgroundColor: "var(".concat(RootVariable.CHECKBOX_HOVER_BG, ")"),
          borderColor: "var(".concat(RootVariable.CHECKBOX_HOVER_BORDER_COLOR, ")")
        },
        '&:disabled': {
          backgroundColor: "var(".concat(RootVariable.CHECKBOX_DISABLED_BG, ")"),
          borderColor: "var(".concat(RootVariable.CHECKBOX_DISABLED_BORDER_COLOR, ")"),
          cursor: 'not-allowed'
        }
      }, "&:checked~.".concat(getRef('icon')), {
        color: "var(".concat(RootVariable.CHECKBOX_CHECKED_COLOR, ")")
      }), "&:checked:hover~.".concat(getRef('icon')), {
        color: "var(".concat(RootVariable.CHECKBOX_CHECKED_COLOR, ")")
      }), "&:checked:disabled~.".concat(getRef('icon')), {
        color: "var(".concat(RootVariable.CHECKBOX_CHECKED_DISABLED_COLOR, ")")
      }),
      inner: _objectSpread2(_objectSpread2({}, hasLabel ? {
        transform: "var(".concat(RootVariable.CHECKBOX_ICON_TRANSFORM, ")")
      } : {}), {}, {
        width: "var(".concat(RootVariable.CHECKBOX_SIZE, ")"),
        height: "var(".concat(RootVariable.CHECKBOX_SIZE, ")")
      }),
      labelWrapper: _objectSpread2({
        alignSelf: 'center',
        fontSize: "var(".concat(RootVariable.CHECKBOX_LABEL_FONT_SIZE, ")"),
        fontWeight: "var(".concat(RootVariable.CHECKBOX_LABEL_FONT_WEIGHT, ")"),
        lineHeight: "var(".concat(RootVariable.CHECKBOX_LABEL_LINE_HEIGHT, ")"),
        fontFamily: 'inherit'
      }, hasLabel ? {
        paddingLeft: "var(".concat(RootVariable.CHECKBOX_LABEL_GAP, ")")
      } : {}),
      label: {
        textWrap: 'wrap',
        paddingLeft: '0',
        color: "var(".concat(RootVariable.CHECKBOX_LABEL_COLOR, ")"),
        '&[data-disabled]': {
          color: "var(".concat(RootVariable.CHECKBOX_LABEL_DISABLED_COLOR, ")"),
          cursor: 'not-allowed'
        }
      },
      icon: {
        ref: getRef('icon'),
        width: "var(".concat(RootVariable.CHECKBOX_SIZE, ")"),
        height: "var(".concat(RootVariable.CHECKBOX_SIZE, ")")
      },
      error: {},
      description: {}
    });
  }, {
    textSize: textSize,
    size: size
  }, breakpoints, ThemeBreakpoints);
});

export { useCheckboxStyle };
//# sourceMappingURL=Checkbox.style.js.map
